var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIceCream = function SvgIceCream(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0B4A3"
    },
    d: "M223.674,227.074L96.241,6.352c-1.695-2.937-4.432-5.037-7.707-5.914 c-3.274-0.877-6.695-0.427-9.631,1.268L53.42,16.418c-2.936,1.695-5.036,4.432-5.913,7.706c-0.878,3.275-0.427,6.696,1.268,9.631 L176.21,254.479c2.348,4.067,6.623,6.343,11.013,6.343c2.152,0,4.331-0.547,6.325-1.698l25.481-14.711 C225.089,240.913,227.173,233.136,223.674,227.074z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B78358"
    },
    points: "69.986,70.494 78.775,85.717 110.419,30.909 101.63,15.686  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B78358"
    },
    points: "133.916,71.607 125.127,56.384 93.483,111.193 102.272,126.415  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B78358"
    },
    points: "157.413,112.305 148.624,97.083 116.98,151.891 125.769,167.113  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B78358"
    },
    points: "180.91,153.004 172.121,137.781 140.478,192.589 149.266,207.812  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B78358"
    },
    points: "204.407,193.701 195.618,178.479 163.974,233.287 172.763,248.509  "
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FDEAAF"
    },
    cx: 259.81,
    cy: 134.16,
    r: 103.3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8CC7C"
    },
    d: "M259.808,30.855c-2.301,0-4.583,0.083-6.846,0.231c47.661,3.525,85.355,48.32,85.355,103.071 s-37.694,99.546-85.355,103.071c2.264,0.148,4.545,0.231,6.846,0.231c57.052,0,103.302-46.25,103.302-103.302 C363.11,77.105,316.86,30.855,259.808,30.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B78358"
    },
    d: "M281.044,256.511c0,19.103-5.182,36.998-14.238,52.354c-2.121,3.607-4.458,7.075-6.998,10.389 c-2.54-3.315-4.877-6.782-6.998-10.389H88.686c-9.056-15.356-14.238-33.251-14.238-52.354c0-57.053,46.245-103.298,103.298-103.298 c33.455,0,63.188,15.902,82.062,40.555C273.131,211.168,281.044,232.912,281.044,256.511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#935D38"
    },
    d: "M259.808,193.768c-18.874-24.653-48.607-40.555-82.062-40.555c-3.085,0-6.136,0.143-9.152,0.408 c24.813,2.627,46.609,17.787,60.93,40.147c11.147,17.4,17.767,39.145,17.767,62.743c0,19.103-4.335,36.998-11.912,52.354h17.43 c2.121,3.607,4.458,7.075,6.998,10.39c2.54-3.315,4.877-6.782,6.998-10.39c9.056-15.356,14.238-33.251,14.238-52.354 C281.044,232.912,273.131,211.168,259.808,193.768z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B78358"
    },
    d: "M216.942,96.112c-4.204,0-7.611-3.408-7.611-7.611v-6.986c0-4.204,3.408-7.611,7.611-7.611 s7.611,3.408,7.611,7.611v6.986C224.553,92.704,221.145,96.112,216.942,96.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B78358"
    },
    d: "M259.808,96.112c-4.204,0-7.611-3.408-7.611-7.611v-6.986c0-4.204,3.408-7.611,7.611-7.611 c4.204,0,7.611,3.408,7.611,7.611v6.986C267.419,92.704,264.012,96.112,259.808,96.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B78358"
    },
    d: "M302.674,96.112c-4.204,0-7.611-3.408-7.611-7.611v-6.986c0-4.204,3.408-7.611,7.611-7.611 c4.204,0,7.611,3.408,7.611,7.611v6.986C310.286,92.704,306.878,96.112,302.674,96.112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B78358"
    },
    d: "M238.375,133.581c-4.204,0-7.611-3.408-7.611-7.611v-6.986c0-4.204,3.408-7.611,7.611-7.611 c4.204,0,7.611,3.408,7.611,7.611v6.986C245.986,130.173,242.579,133.581,238.375,133.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B78358"
    },
    d: "M281.241,133.581c-4.204,0-7.611-3.408-7.611-7.611v-6.986c0-4.204,3.408-7.611,7.611-7.611 c4.204,0,7.611,3.408,7.611,7.611v6.986C288.852,130.173,285.445,133.581,281.241,133.581z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6EFF5"
    },
    d: "M54.685,308.865L54.685,308.865c0,10.288,8.34,18.628,18.628,18.628h372.989 c10.288,0,18.628-8.34,18.628-18.628l0,0c0-10.288-8.34-18.628-18.628-18.628H73.313C63.025,290.237,54.685,298.577,54.685,308.865z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDD6DE"
    },
    d: "M446.303,290.237h-25.451c10.288,0,18.628,8.34,18.628,18.628l0,0 c0,10.288-8.34,18.628-18.628,18.628h25.451c10.288,0,18.628-8.34,18.628-18.628l0,0 C464.931,298.577,456.591,290.237,446.303,290.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#80B9F9"
    },
    d: "M378.981,512H140.635c-10.089,0-18.79-7.088-20.83-16.968L85.206,327.493H434.41l-34.599,167.539 C397.77,504.912,389.07,512,378.981,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3185DB"
    },
    d: "M408.7,327.493l-34.599,167.539c-2.04,9.88-10.741,16.968-20.83,16.968h25.71 c10.089,0,18.79-7.088,20.83-16.968l34.599-167.539H408.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6EFF5"
    },
    points: "409.222,449.462 422.609,384.635 97.007,384.635 110.394,449.462 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDD6DE"
    },
    points: "383.512,449.462 409.222,449.462 422.609,384.635 396.9,384.635 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE81A7"
    },
    d: "M445.172,256.51c0-57.055-46.247-103.292-103.302-103.292c-33.45,0-63.185,15.893-82.061,40.554 c-13.325,17.395-21.241,39.143-21.241,62.738c0,11.803,1.979,23.149,5.632,33.724h50.114v62.18c0,8.267,6.702,14.969,14.969,14.969 s14.969-6.702,14.969-14.969v-9.951c0-8.267,6.702-14.969,14.969-14.969s14.969,6.702,14.969,14.969v41.412 c0,8.267,6.702,14.969,14.969,14.969s14.969-6.702,14.969-14.969v-93.641h55.411C443.193,279.659,445.172,268.313,445.172,256.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA6C9D"
    },
    d: "M341.869,153.218c-2.266,0-4.513,0.079-6.743,0.223c47.329,3.459,84.775,48.27,84.775,103.069 c0,11.803-1.737,23.149-4.944,33.724h24.581c3.654-10.575,5.633-21.921,5.633-33.724 C445.172,199.454,398.925,153.218,341.869,153.218z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIceCream, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ice-cream.07a12b0a.svg";
export { ForwardRef as ReactComponent };